// @core/api/endpoints/secret/delete_database_role.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/secret';

/**
 * Delete database role
 * Deletes a database role. Existing leases from this role remain active until they expire or are revoked.
 */
export async function DeleteDatabaseRole(
  engine_id: string,
  role_name: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/database/roles/:role_name`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':role_name', encodeURIComponent(role_name));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
